export default __webpack_public_path__ + "c6aca521a9b0337ba46aee33e82cf047.svg";